import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaStreetNumberViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map